import { FormulaScreenshot } from 'components/FormulaScreenshot';
import * as React from 'react';
export default {
  FormulaScreenshot,
  React
};